<template>
    <button
        class="h-32 max-w-md py-4 mt-2 mb-10 overflow-hidden rounded-lg shadow w-28 focus:outline-none "
        :class="[!selected ? 'bg-white' : 'bg-blue-600']"
        @click="clicked"
    >
        <base-icon
            width="60"
            height="60"
            icon-name="women"
            :iconColor="iconColor"
        >
            <slot></slot>
        </base-icon>
        <h3
            class="mt-3 "
            :class="[!selected ? 'text-gray-600' : 'text-gray-100']"
        >
            {{ title }}
        </h3>
    </button>
</template>

<script>
export default {
    props: {
        title: {
            type: String
        },
        value: {
            type: String
        }
    },
    data() {
        return {
            selected: this.value.toLowerCase() === this.title.toLowerCase()
        };
    },
    methods: {
        clicked() {
            this.$emit("clicked");
            this.selected = !this.selected;
        },
        setValue() {
            this.selected = false;
        }
    },
    computed: {
        iconColor() {
            return !this.selected ? "gray" : "white";
        }
    }
};
</script>

<style></style>
